import { render, staticRenderFns } from "./turrezervasyonlist.vue?vue&type=template&id=79a98e0e"
import script from "./turrezervasyonlist.vue?vue&type=script&lang=js"
export * from "./turrezervasyonlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports